import { ApiUserRole } from '@/core/generated/api';
import { z } from 'zod';
import { textWithinLimit } from '@/shared/lib/validation';

const person = z.object({
    id: z.guid(),
    appUserId: z.guid(),
    name: z.string(),
});

/** Условия поиска переписки */
export const chatInboxFilterSchema = z.object({
    companionRole: z.enum([ApiUserRole.Client, ApiUserRole.Executor])
        .nullable()
        .optional(),
    clients: z.array(person)
        .max(50),
    executors: z.array(person)
        .max(50),
    channels: z.array(z.number()
        .int()
        .min(1)
        .max(5))
        .max(5),
    companionName: textWithinLimit(100, 'Не больше 100 символов', { trim: true }),
    petName: textWithinLimit(100, 'Не больше 100 символов', { trim: true }),
});
